import MaterialPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';
import { SxProps, Theme } from '@mui/material/styles';

export type PaperProps = MuiPaperProps & {
  outlined?: boolean;
  noPadding?: boolean;
  noMargin?: boolean;
};

const Paper = ({ children, className, outlined, noPadding, noMargin, sx: sxProp, ...props }: PaperProps) => {
  const baseSx: SxProps<Theme> = {
    margin: 'auto',
    width: '100%',
    p: 2,
    mb: 2,
    overflow: 'hidden',
    ...(noPadding && { p: 0 }),
    ...(noMargin && { margin: 'initial' }),
  };

  return (
    <MaterialPaper
      className={className}
      elevation={2}
      sx={[baseSx, ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : [])]}
      variant={outlined ? 'outlined' : 'elevation'}
      {...props}>
      {children}
    </MaterialPaper>
  );
};

export default Paper;
